/**
 * @generated SignedSource<<1c14cdabeedef2e0af80597b3b0a1d35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePdpNetPriceVariant_item$data = {
  readonly isAuctionEnabled: boolean | null;
  readonly isFurniture: boolean | null;
  readonly " $fragmentType": "usePdpNetPriceVariant_item";
};
export type usePdpNetPriceVariant_item$key = {
  readonly " $data"?: usePdpNetPriceVariant_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePdpNetPriceVariant_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "usePdpNetPriceVariant_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFurniture",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "cda5d81209b6e0d734b039af5bf351cd";

export default node;
